import { render } from "./FormulairesStep1.vue?vue&type=template&id=2b185123&scoped=true"
import script from "./FormulairesStep1.vue?vue&type=script&lang=js"
export * from "./FormulairesStep1.vue?vue&type=script&lang=js"

import "./FormulairesStep1.vue?vue&type=style&index=0&id=2b185123&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b185123"]])

export default __exports__